import commonZhHK from './common_zh-HK'

const stocktakeZhHK = {
  stocktake: {
    ...commonZhHK,
  }
}

export default stocktakeZhHK